export default __webpack_public_path__ + "static/media/profile-placeholder.65f9347f.png";